import { render, staticRenderFns } from "./SkeletonRecoMobileCard.vue?vue&type=template&id=3fff04cb"
import script from "./SkeletonRecoMobileCard.vue?vue&type=script&lang=js"
export * from "./SkeletonRecoMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports